"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _Title = _interopRequireDefault(require("../Typography/Title"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['showCaret', 'padding'];
/**
 * A popover content component.
 */

var PopoverContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PopoverContent, _React$Component);

  function PopoverContent() {
    _classCallCheck(this, PopoverContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(PopoverContent).apply(this, arguments));
  }

  _createClass(PopoverContent, [{
    key: "renderCaret",

    /**
     * Render caret
     * @param {bool} showCaret - true to render caret
     * @returns {ReactElement} of caret
     */
    value: function renderCaret(showCaret) {
      if (showCaret) {
        return _react.default.createElement("div", {
          className: "popover-arrow"
        });
      }

      return null;
    }
    /**
     * Render title of popover
     * @returns {node} - Title node
     */

  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var title = this.props.title;

      if (title) {
        var titleNode = title;

        if (typeof title === 'string') {
          titleNode = _react.default.createElement(_Title.default, {
            size: "h3"
          }, title);
        }

        return _react.default.createElement("div", {
          className: "popover-title"
        }, titleNode);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          padding = _this$props.padding,
          showCaret = _this$props.showCaret,
          wrapperProps = _this$props.wrapperProps;
      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, {
        padding: padding,
        showCaret: showCaret
      });

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", _extends({
        className: "".concat(clsPrfx, "-popover-container ").concat(clsPrfx)
      }, styleProps, wrapperProps), _react.default.createElement("div", {
        className: "popover-content"
      }, this.renderTitle(), content), this.renderCaret(showCaret));
    }
  }]);

  return PopoverContent;
}(_react.default.Component);

exports.default = PopoverContent;
PopoverContent.defaultProps = {
  padding: '20px'
};
PopoverContent.propTypes = {
  /**
   * This is the component/text to be placed inside the popover.
   */
  content: _propTypes.default.node.isRequired,

  /**
   * Padding around content.
   */
  padding: _propTypes.default.oneOf(['0px', '20px']),

  /**
   * Show popup caret in relation to position on container.
   */
  showCaret: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['top', 'top-left', 'top-right', 'left', 'left-top', 'left-bottom', 'right', 'right-top', 'right-bottom', 'bottom', 'bottom-left', 'bottom-right'])]),

  /**
   * Title of popover
   */
  title: _propTypes.default.node,

  /**
   * Props to be passed to wrapping dom element
   */
  wrapperProps: _propTypes.default.object
};